import { splitPath } from '@tencent/data-schema-core/lib/utils/path';
import { get } from "lodash-es";
import DataSourceMethodSelector from "./paramsFormComponents/dataSourceMethodSelector";
const getMethodSchema = function () {
  var _this$container, _this$designer, _targetDataStub$schem;
  const currentParams = (_this$container = this.container) === null || _this$container === void 0 || (_this$container = _this$container.stub.parent) === null || _this$container === void 0 ? void 0 : _this$container.value;
  if (!currentParams) return null;
  const {
    dataPath,
    methodName
  } = currentParams;
  if (!dataPath || !methodName) return null;
  const targetDataStub = (_this$designer = this.designer) === null || _this$designer === void 0 || (_this$designer = _this$designer.renderer) === null || _this$designer === void 0 ? void 0 : _this$designer.getStubAtPath(dataPath);
  return targetDataStub === null || targetDataStub === void 0 || (_targetDataStub$schem = targetDataStub.schema.methods) === null || _targetDataStub$schem === void 0 ? void 0 : _targetDataStub$schem.find(x => x.id === methodName);
};
const paramsSchema = {
  type: 'object',
  fields: [{
    id: 'dataPath',
    title: '哪一个数据源',
    type: 'string',
    ui: {
      type: 'dataPathSelector',
      props: {
        filter: schema => {
          var _schema$methods;
          return !!((_schema$methods = schema.methods) !== null && _schema$methods !== void 0 && _schema$methods.length);
        }
      }
    }
  }, {
    id: 'methodName',
    type: 'string',
    title: '调用它的什么操作',
    ui: {
      type: 'dataSourceMethodSelector'
    }
  }, {
    id: 'arguments',
    type: 'array',
    items: {
      type: 'string'
    },
    title: '参数',
    'uc:allowInterop': false,
    ui: {
      type: 'uicore:MethodArgumentsInput',
      props: {
        getMethodSchema
      }
    }
  }]
};
export const invokeDataSourceMethodAtom = {
  id: 'uicore:invokeDataSourceMethod',
  name: '数据源操作',
  desc: '请求接口，并更新页面数据',
  returnValue: '数据源操作的返回值（如果有）',
  category: '数据源',
  paramsSchema: paramsSchema,
  paramsFormComponents: [{
    id: 'dataSourceMethodSelector',
    component: DataSourceMethodSelector,
    propsSchema: {
      type: 'null'
    }
  }
  // MethodArgumentsInput 迁移到 designerComponents 了
  ],
  execute: async (ctx, params) => {
    const {
      dataPath,
      methodName,
      arguments: args = []
    } = params;
    const data = get(ctx.renderer, splitPath(dataPath));
    if (!data) throw new Error(`数据源 ${dataPath} 不存在`);
    const fn = data[methodName];
    if (typeof fn !== 'function') throw new Error(`数据源 ${dataPath} 没有名为 ${methodName} 的方法`);
    const finalArgs = args.map(expr => expr ? ctx.tryEval(expr) : undefined);
    return fn.apply(data, finalArgs);
  },
  validateParams({
    renderer
  }, params) {
    var _dataStub$schema$meth;
    const dataStub = params.dataPath && (renderer === null || renderer === void 0 ? void 0 : renderer.getStubAtPath(params.dataPath));
    if (!dataStub) return '请选择有效的数据源';
    const method = params.methodName && ((_dataStub$schema$meth = dataStub.schema.methods) === null || _dataStub$schema$meth === void 0 ? void 0 : _dataStub$schema$meth.find(x => x.id === params.methodName));
    if (!method) return '请选择有效的操作';
  },
  getDisplayName(step) {
    const {
      dataPath,
      methodName
    } = step.params;
    if (!dataPath || !methodName) return undefined;
    return `调用数据源 ${methodName} 操作（${dataPath}）`;
  }
};